import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    treeCode: []
  },
  mutations: {
    setTreeCode(state, payload) {
      let defaultCode = [
        // 'userM',
        // 'userM-look',
        // 'userM-add',
        // 'userM-del',
        // 'userM-put',
        // 'userM-role',
        // 'userM-addDep',
        // 'userM-putDep',
        // 'userM-delDep',
        // 'userM-addUser',
        // 'userM-putUser',
        // 'userM-delUser',
        // 'userM-putUserStatus',
        // 'userM-shareInfo',
        // 'userM-resetPass'
      ]
      state.treeCode = [...payload, ...defaultCode]
    }
  },
  actions: {},
  modules: {}
})
